import { TQuestion } from "../../../api/type"
import QuestionDetailSection from "./QuestionDetailSection"

type QuestionDetailPanelProps = {
  question: TQuestion
}

const QuestionDetailPanel = ({ question }: QuestionDetailPanelProps) => (
  <div className="question-detail__main">
    <QuestionDetailSection
      title="Question"
      html={question.question}
      artifacts={question.question_artifacts}
    />
    <QuestionDetailSection title="Answer" html={question.answer} />
    <QuestionDetailSection
      title="Solution"
      html={question.solution}
      artifacts={question.solution_artifacts}
    />
    <QuestionDetailSection
      title="Marking scheme"
      html={question.marking_scheme}
    />
  </div>
)

export default QuestionDetailPanel
